import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import { withStyles, MenuItem, ListItemText, ClickAwayListener, Grow, Paper, Popper } from '@material-ui/core';
import moment from 'moment'
import CustomButton from '../../../../common/components/UI/Button/Button';
import { translate } from 'react-i18next';
import { workplanTableBody } from '../../../styles/workplanStyles';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPause, faStop } from '@fortawesome/pro-solid-svg-icons';
import { exists } from '../../../../common/utilities/utilitiesFunctions';

const styles = theme => (workplanTableBody(theme));

class EmployeeOptionsMenu extends Component {
    constructor(props) {
        super(props);
        this.buttonRef = createRef();
        this.state = {
            open: false
        }
    }

    handleClose = () => {
        const { open } = this.state;

        this.setState({ open: !open });
    }

    handleAction = (action) => {
        const { handleEmployeeActions, shiftLine, shiftLineOwner } = this.props;
        const { open } = this.state;

        this.setState({ open: !open });
        handleEmployeeActions(action, shiftLine, shiftLineOwner);
    }

    genMenuItems = (action, disabled) => {
        const { t } = this.props;

        const StyledMenuItem = withStyles((theme) => ({
            root: {
                '&:focus': {
                    backgroundColor: theme.palette.primary.main,
                    '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
                        color: theme.palette.common.white,
                    },
                },
            },
        }))(MenuItem);

        return (
            <StyledMenuItem
                disabled={disabled}>
                <ListItemText
                    onClick={() => { this.handleAction(action) }}
                    primary={t('workPlanView.global.' + action)}
                />
            </StyledMenuItem>)
    }

    render() {
        const { buttonIcon, anchorRef, classes, t, shiftLine, marginTop, shiftLineOwner, accessProfiles, isEmployeeStopped, isAsyncTaskProcessing } = this.props;
        const { open } = this.state;
        return (
            <React.Fragment>
                <span ref={anchorRef}
                    style={{ marginTop }}
                    className={classes.ButtonChip}
                    onClick={() => { this.setState({ open: !open }) }}>
                    {buttonIcon}
                </span>
                <Popper
                    open={open}
                    anchorEl={anchorRef.current}
                    placement={'bottom-start'}
                    transition
                    className={classes.popoverEeOptions}
                >
                    {({ TransitionProps, placement }) => (
                        <Grow
                            {...TransitionProps}
                            style={{
                                transformOrigin: placement === 'bottom' ? 'center top' : 'right bottom',
                            }}
                        >
                            <Paper>
                                <ClickAwayListener onClickAway={this.handleClose}>
                                    <div className={classes.menuActions}>
                                        {shiftLine.owners.length > 0 ?
                                            <div className={classes.menuHeaderActions}>
                                                <CustomButton
                                                    disabled={shiftLine.states.length === 0 || !accessProfiles.manageAssignments || isEmployeeStopped || isAsyncTaskProcessing}
                                                    onClick={() => { this.handleAction('PauseShiftLineOwner') }}
                                                    variant="contained"
                                                    size="small"
                                                    color="secondary"
                                                    className={classes.buttonHeaderAction}
                                                >
                                                    {<FontAwesomeIcon icon={faPause} />}
                                                    <div className={classes.divButtonAction}>{t('workPlanView.global.pause')}</div>
                                                </CustomButton>
                                                <CustomButton
                                                    disabled={shiftLine.states.length === 0 || !accessProfiles.manageAssignments || isEmployeeStopped || isAsyncTaskProcessing}
                                                    onClick={() => { this.handleAction('StopShiftLineOwner') }}
                                                    variant="contained"
                                                    size="small"
                                                    color="secondary"
                                                    className={classes.buttonHeaderAction}
                                                >
                                                    {<FontAwesomeIcon icon={faStop} />}
                                                    <div className={classes.divButtonAction}>{t('workPlanView.global.stop')}</div>
                                                </CustomButton>
                                            </div>
                                            : ''}
                                        {((shiftLineOwner !== null && !exists(shiftLineOwner.parentId)) || shiftLineOwner === null) ?
                                            <React.Fragment>
                                                <div className={classes.menuOtherActions}>
                                                    {
                                                        this.genMenuItems('ManageAssignment',
                                                            shiftLine.states.length === 0 
                                                                || (shiftLine.states.length > 0 && (shiftLine.employeeId === null || shiftLine.employeeId === null))
                                                                || !shiftLine.summaryReliefs.some(segment => (segment.sumSummaryReliefStatusLabel === 'UnAssign' || segment.reliefId) && moment(segment.endDate).isAfter(moment()))
                                                                || !accessProfiles.manageAssignments
                                                                || isAsyncTaskProcessing
                                                        )
                                                    }
                                                </div>
                                                <div className={classes.menuOtherActions}>
                                                    {this.genMenuItems('ManageOwners', !accessProfiles.manageAssignments || isAsyncTaskProcessing)}
                                                </div>
                                            </React.Fragment>
                                            : ''}
                                    </div>
                                </ClickAwayListener>
                            </Paper>
                        </Grow>
                    )}
                </Popper>
            </React.Fragment >
        )
    }
}

const mapStateToProps = state => {
    return {
        accessProfiles: state.accessProfiles,
    }
}

export default connect(mapStateToProps)(translate('workplanManager')(withStyles(styles)(EmployeeOptionsMenu)));